import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Button,
    Col,
    Divider,
    Image,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Input, Upload, Spin, Select, Skeleton,
} from 'antd';
import ReactQuill, { Quill } from 'react-quill';
import TextArea from 'antd/lib/input/TextArea';
import imgIcon from '../../../src/img/image-icon.png';
import "react-quill/dist/quill.snow.css";
import { fillEn } from 'client/src/methods/forms';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
    UploadOutlined,
    ArrowLeftOutlined,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import { getImageUrl, UploadImage } from 'shared/services/Utility';
import arrowLeft from '../../../src/img/arrow-left.png';

interface Props {
    location: any;
    selectedLanguage:any
}

const { Title } = Typography;
const { Option } = Select;
export default function CategoryForm(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [item, setItem] = useState(null as any);
    const [image, setImage] = useState({ image: null, imageId: null } as any);
    const [uploading, setUploading] = useState(false);
    const [selectedLang, setSelectedLang] = useState('en' as any);
    const [lang, setLang] = useState('' as any);
    const refreshItem = async () => {
        try {
            setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchCategoryById(RouteParams['id']);
            setItem({
                ...data,
            });
            setImage({ image: getImageUrl(data.image), imageId: data.image_id });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    const uploadImage = async (file: any) => {
        setUploading(true);
        setImage({ image: null, imageId: null });
        const { image, imageId, error } = await UploadImage(file);
        if (error) {
            notification.error({ message: error });
        }
        setImage({ image, imageId });
        setUploading(false);
    };
    useEffect(() => {
        if (RouteParams['id']) {
            refreshItem();
        } else {
            setFetching(false);
        }
        let localLang = localStorage.getItem("language")
        if(localLang != undefined && localLang != null && localLang != ''){
            setSelectedLang(localLang)
        }
        setLang(localStorage.getItem('language'));
        console.log('localLanguage',selectedLang)
    }, []);

    if (fetching) {
        return <Skeleton active={true}/>;
    }
    return (
        <div className={'list-page-wrapper'}>
            <div className="container-fluid">
                <div className={'d-flex justify-space-between mb-3'}>
                    <div className='col-md-12 p-0 d-flex align-items-center'>
                        <div className={lang == 'ar' ? '' : 'mr-4'}>
                        <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                        </div>
                        <div className={lang == 'ar' ? 'mr-2 text-sm-right' : 'text-sm-right'}><h3 className='mb-0'>{RouteParams['mode'] === 'create' ? t('category.create') : ''}</h3></div>
                    </div>
                </div>
                <div className={lang === 'ar' ? 'row text-right' : 'row'}>
                    <div className='col-md-12'>
                        <div className='bg-white p-3 br-5px'>
                            <div className='pt-3 pb-3 pl-4 pr-6rem'>
                            <Row>
                                <Col lg={10} md={10} sm={24} xs={24}>
                                    <h5  className={lang == 'ar' ? 'mr-4' : 'mt-4'}>{t('genDict.UploadImage')}</h5>
                                    <p className={lang == 'ar' ? 'mr-4' : 'text-secondary'}>{t('genDict.UploadImageParagraph')}</p>
                                </Col>
                                <Col lg={14} md={14} sm={24} xs={24}>
                                {
                                    uploading ? <Spin/> : (
                                        image.image ? <div>
                                            
                                            <div className="d-flex align-items-center">
                                                <div className="uploadeImgBg mr-2">
                                                    <Image src={image.image} id="orgLogo" className="uploaded-img-cat" height={'48px'} width={'48px'}/>
                                                </div>
                                                <div>
                                                    {
                                                        RouteParams['mode'] !== 'view' && <Button className='btn btn-default' onClick={() => setImage({
                                                            image: null,
                                                            imageId: null,
                                                        })}>{t('genDict.remove')}</Button>
                                                        
                                                    }
                                                </div>
                                            </div>
                                            
                                        </div> : <Upload beforeUpload={(file) => {
                                                    if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                                                        notification.error({ message: `PNG/JPG/JPEG ${t('genDict.required')}` });
                                                    }
                                                        uploadImage(file);
                                                        return file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
                                                    }}>
                                                    <div className={lang === 'ar' ? 'd-flex align-items-center gap-2': 'd-flex align-items-center'}>
                                                        <div className="mr-2">
                                                                <img src={imgIcon} className="logo-org"/>
                                                            {/* <i className="fa fa-picture-o logo-org"></i> */}
                                                            {/* <img src="#" id="orgLogo" className="uploaded-img-cat" height="48" width="48" style={{display:'none'}}/> */}
                                                        </div>
                                                        <div>
                                                            <Button className="btn btn-default">{t('genDict.uploadImage')}</Button>
                                                        </div>
                                                    </div>
                                                </Upload>
                                    )
                                }
                                </Col>
                            </Row>
                            <hr/>
                            <Form
                                size="large"
                                form={form}
                                initialValues={item}
                                fields={[]}
                                onFinish={(value) => {
                                    if (!image.imageId) {
                                        notification.error({ message: t('image.required') });
                                        return;
                                    }
                                    const reqObj: any = value;
                                    console.log('reqObj',reqObj)
                                    // return
                                    reqObj['image_id'] = image.imageId;
                                    setSaving(true);
                                    if (item && item.id) {
                                        API_SERVICE.updateCategories(item.id, reqObj).then((d) => {
                                            history.goBack();
                                        }).catch((e) => {
                                            notification.error({ message: API_SERVICE.handleErrors(e) });
                                            setSaving(false);
                                        });
                                    } else {
                                        API_SERVICE.createCategories(reqObj).then((d) => {
                                            history.goBack();
                                        }).catch((e) => {
                                            notification.error({ message: API_SERVICE.handleErrors(e) });
                                            setSaving(false);
                                        });
                                    }
                                }}
                                layout="vertical"
                                requiredMark={true}
                            >
                                    <Row>
                                        <Col lg={10} md={10} sm={24} xs={24} className="mt-4">
                                            <h5 className={lang == 'ar' ? 'mr-4' : ''}>{t('genDict.CategoryInformation')}</h5>
                                            <p className={lang == 'ar' ? 'mr-4' : 'text-secondary'}>{t('genDict.CategoryInformationParagraph')}</p>
                                        </Col>
                                        
                                        <Col lg={14} md={14} sm={24} xs={24} className="mt-4">
                                        <Form.Item
                                            // label={t('category.name'+selectedLang.charAt(0).toUpperCase()+ selectedLang.slice(1)+'.label')}
                                            label={t('name.label')}
                                            name={['name', selectedLang]}
                                            rules={[
                                                { required: true, message: t('name.required') },
                                            ]}>
                                            <Input className='form-control' disabled={RouteParams['mode'] === 'view'}/>
                                        </Form.Item> 
                                        <Form.Item
                                            // initialValue={item? item.description.de:''}
                                            // label={t('category.description'+selectedLang.charAt(0).toUpperCase()+ selectedLang.slice(1)+'.label')}
                                            label={t('description.label')}
                                            name={['description', selectedLang]}
                                            rules={[
                                                { required: true, message: t('description.required') },
                                            ]}
                                        >
                                            {RouteParams['mode'] === 'view'?
                                            <Input className='form-control' disabled/>
                                            :<TextArea className='form-control' cols={4} />
                                            }
                                        </Form.Item>
                                        {/* <Form.Item
                                            initialValue={item? item.description.en:''}
                                            label={t('category.description.label')}
                                            name={['description', 'en']}
                                            rules={[]}>
                                            {RouteParams['mode'] === 'view'?
                                            <Input className='form-control' disabled/>
                                            :<TextArea className='form-control' cols={4} />
                                            }
                                        </Form.Item> */}
                                            
                                        </Col>
                                    </Row>
                                    <hr/>
                                    <Row>
                                        <Col lg={24} md={24} sm={24} xs={24}>
                                            {
                                                RouteParams['mode'] !== 'view' && <Form.Item>
                                                    <Button
                                                        htmlType="submit"
                                                        loading={saving || uploading}
                                                        size={'large'}
                                                        className="submit btn-blue float-right"
                                                    >
                                                        {t('genDict.save')}
                                                    </Button>
                                                    <Button                                 
                                                        htmlType="reset"
                                                        size={'large'}
                                                        className="reset mr-3 btn-default float-right"
                                                    >
                                                        {t('genDict.cancel')}
                                                    </Button>
                                                </Form.Item>
                                            }
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
